import { groups } from 'client/components/core/Sidebar/components/Toolbox/toolboxGroups'
import { pageTypes } from 'common/constants/pageTypes'
import toolBoxTypes from 'common/constants/toolBoxTypes'
import { PageTypeEnum } from '../../common/enums/PageTypeEnum'
import LibraryElementEnum from '../enums/LibraryElementEnum'

const common = {
  [groups.text]: [
    LibraryElementEnum.LibraryText,
    LibraryElementEnum.LibraryHeadline,
    LibraryElementEnum.LibraryBulletList,
    LibraryElementEnum.LibraryContentBox,
  ],
  [groups.media]: [
    LibraryElementEnum.LibraryImage,
    LibraryElementEnum.LibraryVideo,
    LibraryElementEnum.LibraryAudio,
    LibraryElementEnum.LibraryCarousel,
  ],
  [groups.layout]: [
    LibraryElementEnum.LibraryColumn3,
    LibraryElementEnum.LibraryColumn4,
    LibraryElementEnum.LibraryColumn6,
    LibraryElementEnum.LibraryRow,
    LibraryElementEnum.LibrarySection,
  ],
  [groups.form]: [
    // LibraryElementEnum.LibraryForm, // TODO: uncomment when form is ready
    LibraryElementEnum.LibraryField,
    LibraryElementEnum.LibraryButton,
    LibraryElementEnum.LibraryCheckbox,
    LibraryElementEnum.LibraryOptInRecaptcha,
  ],
  [groups.social]: [
    LibraryElementEnum.LibraryTwitterTweetButton,
    LibraryElementEnum.LibrarySurvey,
  ],
  [groups.other]: [
    LibraryElementEnum.LibraryCountdown,
    LibraryElementEnum.LibraryMenu,
    LibraryElementEnum.LibraryHorizontalLine,
    LibraryElementEnum.LibraryRawHTML,
    LibraryElementEnum.LibraryFaq,
  ],
}

const firstGroups = {
  [groups.text]: common[groups.text],
  [groups.layout]: common[groups.layout],
}

const lastGroups = {
  [groups.media]: common[groups.media],
  [groups.social]: common[groups.social],
  [groups.other]: common[groups.other],
}

export default {
  [PageTypeEnum.WebsiteHome]: {
    ...common,
    [groups.form]: [
      // LibraryElementEnum.LibraryForm, // TODO: uncomment when form is ready
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryCalendar,
    ],
    // TODO: hide for library
    // [groups.other]: [
    //   ...common[groups.other],
    //   LibraryElementEnum.LibraryWebsiteLogo,
    // ],
  },
  [PageTypeEnum.WebsiteDefault]: {
    ...common,
    [groups.social]: [
      LibraryElementEnum.LibraryTwitterTweetButton,
      LibraryElementEnum.LibrarySurvey,
    ],
    [groups.form]: [
      // LibraryElementEnum.LibraryForm, // TODO: uncomment when form is ready
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryCalendar,
    ],
    // TODO: hide for library
    // [groups.other]: [
    //   ...common[groups.other],
    //   LibraryElementEnum.LibraryWebsiteLogo,
    // ],
  },
  [PageTypeEnum.WebsiteLogin]: {
    ...common,
    [groups.social]: [
      LibraryElementEnum.LibraryTwitterTweetButton,
      LibraryElementEnum.LibrarySurvey,
    ],
    // TODO: hide for library
    // [groups.other]: [
    //   ...common[groups.other],
    //   LibraryElementEnum.LibraryWebsiteLogo,
    // ],
  },
  [PageTypeEnum.WebsitePricing]: {
    ...common,
    [groups.social]: [
      LibraryElementEnum.LibraryTwitterTweetButton,
      LibraryElementEnum.LibrarySurvey,
    ],
    [groups.payment]: [LibraryElementEnum.LibraryPriceElement],
  },
  [PageTypeEnum.FunnelContactUs]: {
    ...firstGroups,
    [groups.form]: [
      ...common[groups.form],
      LibraryElementEnum.LibraryContactUs,
    ],
    [groups.media]: common[groups.media],
    [groups.social]: common[groups.social],
    [groups.other]: common[groups.other],
  },
  [pageTypes.offerPage]: {
    ...firstGroups,
    [groups.form]: common[groups.form],
    [groups.payment]: [
      LibraryElementEnum.LibraryPaymentButton,
      LibraryElementEnum.LibraryPaymentMethod,
      LibraryElementEnum.LibraryCustomerType,
      LibraryElementEnum.LibraryProduct,
      LibraryElementEnum.LibraryOfferPrice,
      LibraryElementEnum.LibraryAgreement,
      LibraryElementEnum.LibraryOrderBump,
      LibraryElementEnum.LibraryCoupon,
      LibraryElementEnum.LibraryTwoStepPaymentForm,
      LibraryElementEnum.LibraryShippingFees,
      LibraryElementEnum.LibraryPaidCalendar,
    ],
    ...lastGroups,
    [groups.social]: [LibraryElementEnum.LibraryTwitterTweetButton],
  },
  [pageTypes.offerInner]: {
    ...common,
  },
  [pageTypes.offerUpSellPage]: {
    ...firstGroups,
    [groups.form]: common[groups.form],
    [groups.payment]: [
      LibraryElementEnum.LibraryOfferPrice,
      LibraryElementEnum.LibraryProduct,
      LibraryElementEnum.LibraryUpsellAgreeButton,
      LibraryElementEnum.LibraryUpsellDisagreeButton,
      LibraryElementEnum.LibraryCheckbox,
    ],
    ...lastGroups,
  },
  [pageTypes.offerThankYouPage]: {
    ...firstGroups,
    [groups.payment]: [
      LibraryElementEnum.LibraryOrderSummary,
      LibraryElementEnum.LibraryCheckbox,
    ],
    [groups.form]: common[groups.form],
    ...lastGroups,
  },
  [PageTypeEnum.OfferInnerThankYouPage]: {
    ...firstGroups,
    [groups.payment]: [
      LibraryElementEnum.LibraryOrderSummary,
      LibraryElementEnum.LibraryCheckbox,
    ],
    [groups.form]: common[groups.form],
    ...lastGroups,
  },
  [pageTypes.inactiveFunnelPage]: {
    ...common,
  },
  [pageTypes.salesPage]: {
    ...firstGroups,
    [groups.form]: [...common[groups.form], LibraryElementEnum.LibraryCalendar],
    [groups.payment]: [
      LibraryElementEnum.LibrarySalesRedirectionButton,
      LibraryElementEnum.LibraryProduct,
    ],
    ...lastGroups,
  },
  [pageTypes.customLogin]: {
    ...firstGroups,
    [groups.media]: common[groups.media],
    [groups.other]: [
      ...common[groups.other],
      LibraryElementEnum.LibraryCustomLogin,
    ],
  },
  [pageTypes.inline]: {
    ...common,
    [groups.form]: [...common[groups.form], LibraryElementEnum.LibraryCalendar],
  },
  [pageTypes.popup]: {
    ...common,
    [groups.form]: [...common[groups.form], LibraryElementEnum.LibraryCalendar],
  },
  [pageTypes.squeeze]: {
    ...common,
    [groups.form]: [...common[groups.form], LibraryElementEnum.LibraryCalendar],
  },
  [PageTypeEnum.LinkInBio]: {
    ...common,
  },
  [pageTypes.courseIntroduction]: {
    ...common,
  },
  [pageTypes.lecture]: {
    ...firstGroups,
    [groups.form]: [LibraryElementEnum.LibraryOpenUrlButton],
    ...lastGroups,
    [groups.other]: [
      LibraryElementEnum.LibraryCountdown,
      LibraryElementEnum.LibraryMenu,
      LibraryElementEnum.LibraryHorizontalLine,
      LibraryElementEnum.LibraryRawHTML,
      LibraryElementEnum.LibraryFaq,
      LibraryElementEnum.LibraryContentTable,
    ],
    [groups.social]: [LibraryElementEnum.LibraryTwitterTweetButton],
  },
  [pageTypes.webinarRegistration]: {
    ...firstGroups,
    [groups.webinar]: [
      LibraryElementEnum.LibraryWebinarRegistrationDate,
      toolBoxTypes.TOOLBOX_START_TIMER,
    ],
    [groups.form]: common[groups.form],
    ...lastGroups,
  },
  [pageTypes.webinarSession]: {
    ...firstGroups,
    [groups.form]: common[groups.form],
    [groups.webinar]: [
      LibraryElementEnum.LibraryWebinarCallToAction,
      LibraryElementEnum.LibraryWebinarSessionVideo,
    ],
    [groups.media]: [LibraryElementEnum.LibraryImage],
    [groups.social]: common[groups.social],
    [groups.other]: common[groups.other],
  },
  [pageTypes.webinarThankYou]: {
    ...firstGroups,
    [groups.form]: common[groups.form],
    [groups.webinar]: [
      LibraryElementEnum.LibraryWebinarSessionDateTime,
      LibraryElementEnum.LibraryWebinarSessionLink,
    ],
    ...lastGroups,
  },
  [pageTypes.optInThankYou]: {
    ...common,
  },
  [pageTypes.infoPage]: {
    [groups.text]: common[groups.text],
    [groups.media]: common[groups.media],
    [groups.form]: [LibraryElementEnum.LibraryOpenUrlButton],
    [groups.layout]: common[groups.layout],
  },
  [pageTypes.blogPostBody]: {
    ...firstGroups,
    [groups.blog]: [LibraryElementEnum.LibraryContentTable],
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryOptInRecaptcha,
    ],
    ...lastGroups,
  },
  [pageTypes.blogPostLayout]: {
    ...firstGroups,
    [groups.blog]: [
      LibraryElementEnum.LibraryBlogPostBody,
      LibraryElementEnum.LibraryBlogPostTitle,
      LibraryElementEnum.LibraryBreadcrumbs,
      LibraryElementEnum.LibraryBlogPostImage,
      LibraryElementEnum.LibraryBlogPostDate,
      LibraryElementEnum.LibraryBlogPostCategories,
      LibraryElementEnum.LibraryBlogLatestPosts,
      LibraryElementEnum.LibraryLatestBlogPostsCarousel,
    ],
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryContactUs,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryOptInRecaptcha,
    ],
    ...lastGroups,
  },
  [pageTypes.blogStatic]: {
    ...firstGroups,
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryContactUs,
      LibraryElementEnum.LibraryOptInRecaptcha,
      LibraryElementEnum.LibraryCalendar,
    ],
    [groups.blog]: [
      LibraryElementEnum.LibraryBlogLatestPosts,
      LibraryElementEnum.LibraryBlogPostListing,
      LibraryElementEnum.LibraryBlogCategoryTitle,
      LibraryElementEnum.LibraryBlogCategoryDescription,
      LibraryElementEnum.LibraryLatestBlogPostsCarousel,
      LibraryElementEnum.LibraryContentTable,
    ],
    ...lastGroups,
  },
  [pageTypes.blogPostListing]: {
    ...firstGroups,
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryContactUs,
      LibraryElementEnum.LibraryOptInRecaptcha,
      LibraryElementEnum.LibraryCalendar,
    ],
    [groups.blog]: [
      LibraryElementEnum.LibraryBlogLatestPosts,
      LibraryElementEnum.LibraryBlogPostListing,
      LibraryElementEnum.LibraryBlogCategoryTitle,
      LibraryElementEnum.LibraryBlogCategoryDescription,
      LibraryElementEnum.LibraryLatestBlogPostsCarousel,
      LibraryElementEnum.LibraryContentTable,
    ],
    ...lastGroups,
  },
  [pageTypes.blogHome]: {
    ...firstGroups,
    [groups.blog]: [
      LibraryElementEnum.LibraryBlogLatestPosts,
      LibraryElementEnum.LibraryBlogPostListing,
      LibraryElementEnum.LibraryLatestBlogPostsCarousel,
      LibraryElementEnum.LibraryContentTable,
    ],
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryOptInRecaptcha,
      LibraryElementEnum.LibraryCalendar,
    ],
    ...lastGroups,
  },
  [pageTypes.blogSearch]: {
    ...firstGroups,
    [groups.blog]: [
      LibraryElementEnum.LibrarySearchResults,
      LibraryElementEnum.LibrarySearch,
    ],
    ...lastGroups,
  },
  [pageTypes.blogLayout]: {
    ...firstGroups,
    [groups.blog]: [
      LibraryElementEnum.LibraryBlogContentPlaceholder,
      LibraryElementEnum.LibrarySearch,
    ],
    [groups.form]: [
      LibraryElementEnum.LibraryField,
      LibraryElementEnum.LibraryButton,
      LibraryElementEnum.LibraryContactUs,
      LibraryElementEnum.LibraryCheckbox,
      LibraryElementEnum.LibraryOptInRecaptcha,
    ],
    ...lastGroups,
  },
  [PageTypeEnum.NotFound]: {
    ...firstGroups,
    [groups.media]: common[groups.media],
    [groups.form]: [LibraryElementEnum.LibraryOpenUrlButton],
    [groups.other]: [
      LibraryElementEnum.LibraryMenu,
      LibraryElementEnum.LibraryHorizontalLine,
      LibraryElementEnum.LibraryRawHTML,
    ],
  },
}
